export default {
      id: "ic_burger-usage",
      viewBox: "0 0 21 16",
      url: "../dist/images/" + "sprite.svg#ic_burger-usage",
      toString: function () {
        return this.url;
      }
    }